import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { id: "user-setting" }
const _hoisted_5 = { class: "profile-img" }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = { for: "imageUpload" }
const _hoisted_8 = { class: "profile-img-wrapper" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "profile-edit-attention" }
const _hoisted_11 = { class: "attention" }
const _hoisted_12 = { class: "contents-profile-setting" }
const _hoisted_13 = { class: "member-info-required" }
const _hoisted_14 = { class: "contents-profile-setting-input-login-id" }
const _hoisted_15 = { class: "contents-profile-setting" }
const _hoisted_16 = { class: "contents-profile-setting-input-login-id" }
const _hoisted_17 = { class: "contents-profile-setting" }
const _hoisted_18 = { class: "member-info-required" }
const _hoisted_19 = {
  class: "contents-profile-setting-input-attribute",
  id: "attribute"
}
const _hoisted_20 = {
  class: "info-radio",
  id: "attribute"
}
const _hoisted_21 = ["id", "value"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "contents-profile-setting" }
const _hoisted_24 = { class: "member-info-required" }
const _hoisted_25 = { class: "contents-profile-setting-input-birth-date" }
const _hoisted_26 = {
  class: "birthday-select",
  id: "birth_date"
}
const _hoisted_27 = { class: "select-wrap" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "select-text" }
const _hoisted_30 = { class: "select-wrap" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "select-text" }
const _hoisted_33 = { class: "select-wrap" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "select-text" }
const _hoisted_36 = { class: "contents-profile-setting" }
const _hoisted_37 = { class: "contents-profile-setting-input-zipcode" }
const _hoisted_38 = {
  class: "input-zipcode-area",
  id: "zip_code"
}
const _hoisted_39 = { class: "contents-profile-setting" }
const _hoisted_40 = {
  class: "contents-profile-setting-input-gender",
  id: "gender"
}
const _hoisted_41 = {
  class: "info-radio",
  id: "gender"
}
const _hoisted_42 = ["id", "value"]
const _hoisted_43 = ["for"]
const _hoisted_44 = { class: "contents-profile-setting" }
const _hoisted_45 = {
  class: "contents-profile-setting-input-status_patient_group",
  id: "status_patient_group"
}
const _hoisted_46 = {
  class: "info-radio",
  id: "status_patient_group"
}
const _hoisted_47 = ["id", "value"]
const _hoisted_48 = ["for"]
const _hoisted_49 = { class: "contents-profile-setting" }
const _hoisted_50 = { class: "contents-profile-setting-input-login-id" }
const _hoisted_51 = { class: "identify-code-label" }
const _hoisted_52 = { class: "contents-profile-setting" }
const _hoisted_53 = { class: "contents-profile-setting-input-hospital-name" }
const _hoisted_54 = { class: "hospital-name-wrapper" }
const _hoisted_55 = { class: "hospital-name-label" }
const _hoisted_56 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_57 = { class: "hospital-name-btn-wrapper" }
const _hoisted_58 = { class: "add-hospital-name-btn-text" }
const _hoisted_59 = {
  key: 1,
  class: "limit-hospital-name-btn"
}
const _hoisted_60 = { class: "contents-profile-setting" }
const _hoisted_61 = {
  class: "contents-profile-setting-text",
  id: "disease_name"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 1,
  class: "input-required-error active"
}
const _hoisted_64 = { class: "contents-profile-setting" }
const _hoisted_65 = {
  class: "contents-profile-setting-text",
  id: "tag_name"
}
const _hoisted_66 = { class: "contents-profile-setting-button" }

import { ref, reactive, onMounted, computed, toRaw } from "vue";
import { useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import { Profile } from "@/models/profile/profile";
import { _$t } from "@/utils/i18n";
import code from "@/constants/code";
import DiseaseModal from "./DiseaseModal.vue";
import InterestModal from "./InterestModal.vue";
import CommonMessage from "@/views/base/CommonMessage.vue";

// ---- Constant ----------------------------------------------
const componentId = "generalpurpose04-02-a";
const menuId = "profile";
type ProfileInfo = {
  userloginid: string;
  attribute: number;
  attributelabel: string;
  nickname: string;
  birthdate: string;
  zipcode: string;
  gender: string;
  genderlabel: string;
  identifycode: string;
  hospitals: string[]; //入力欄生成のため配列で受け取る
  diseasecodes: string[];
  diseasenames: string;
  otherdiseasename: string;
  tagids: number[];
  tagnames: string;
  image: string;
  imageUpdateFlg: boolean;
  isStakeholder: boolean;
  statuspatientgroup: string;
};

// ---- Variable ----------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileEdit',
  setup(__props) {

const router = useRouter();
const profile = new Profile();
const isError = ref(false);
const isSessionError = ref(false);
const fieldErrors = ref<Record<string, string>>({});
const isModalOpen = ref(false);
const isDiseaseModalOpen = ref(false);
const previewImage = ref("/server/necs/images/profile_icon.png");

// ---- Types -------------------------------------------------
const profileInfo = ref<ProfileInfo>({
  userloginid: "",
  attribute: 0,
  attributelabel: "",
  nickname: "",
  birthdate: "",
  zipcode: "",
  gender: "",
  genderlabel: "",
  identifycode: "",
  hospitals: [],
  diseasecodes: [],
  diseasenames: "",
  otherdiseasename: "",
  tagids: [],
  tagnames: "",
  image: "",
  imageUpdateFlg: false,
  isStakeholder: false,
  statuspatientgroup: "",
});

// 属性の選択肢を取得する
const attributeOptions = computed(() => code.attributes.attribute || {});

// 性別の選択肢を取得する
const genderOptions = computed(() => code.attributes.gender || {});

// 患者会への所属の選択肢を取得する
const statusPatientGroupOptions = computed(
  () => code.attributes.statusPatientGroupOptions || []
);

// 生年月日の年リストを生成する
const years = computed(() => {
  const start = new Date().getFullYear();
  const end = start - 100;
  const years: number[] = [];

  for (let year = start; year >= end; year--) {
    years.push(year);
  }
  return years;
});

const months = computed(() => Array.from({ length: 12 }, (_, i) => i + 1));
const days = computed(() => Array.from({ length: 31 }, (_, i) => i + 1));

// フォーム用の生年月日に変換する
const birthDateParts = computed(() => {
  const [year, month, day] = profileInfo.value.birthdate.split("/");
  return {
    year: year,
    month: parseInt(month),
    day: parseInt(day),
  };
});

const zipcode = computed(() => {
  const zip = profileInfo.value.zipcode || "";
  const [zipCodeFirst, zipCodeSecond] = zip.split("-");
  return {
    first: zipCodeFirst || "",
    second: zipCodeSecond || "",
  };
});

// ----- Function -----------------------------------------------
// メッセージダイアログ関連情報
let messageConfig = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing();
    messageConfig.message = message;
    messageConfig.show = true;
  },
  close: (): void => {
    processend();
    messageConfig.show = false;
    messageConfig.message = "";
    if (isSessionError.value) {
      window.location.href = "/cms/login";
    } else if (!isError.value) {
      // 画面遷移
      router.push({ name: "Profile" });
    }
  },
});

// 病院名を追加
const addHospital = () => {
  if (profileInfo.value.hospitals.length < 10) {
    profileInfo.value.hospitals.push("");
  }
};

// 「関心のあるもの」選択肢の更新
const updateInterests = (selectedIds: number[], selectedNames: string) => {
  // 選択前と同じかをチェックする
  profileInfo.value.tagids = selectedIds;
  profileInfo.value.tagnames = selectedNames;
  isModalOpen.value = false;
};

// 「病名」選択肢の更新
const updateDiseases = (
  selectedCodes: string[],
  selectedDiseaseNames: string,
  otherDiseaseName: string,
  isStakeholder = false
) => {
  // 選択前と同じかをチェックする
  profileInfo.value.diseasecodes = selectedCodes;
  profileInfo.value.diseasenames = selectedDiseaseNames;
  profileInfo.value.otherdiseasename = otherDiseaseName;
  profileInfo.value.isStakeholder = isStakeholder;
  isDiseaseModalOpen.value = false;
  fieldErrors.value.diseasecodes = "";
};

// ----- Function -----------------------------------------------
// 画像アップロード処理
const handleImageUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    const reader = new FileReader();

    reader.onload = (e) => {
      if (e.target?.result) {
        previewImage.value = e.target.result as string;
        profileInfo.value.image = previewImage.value;
        profileInfo.value.imageUpdateFlg = true;
      }
    };

    reader.readAsDataURL(target.files[0]);
  }
};

// プロフィール情報取得
const fetchProfileInfo = async () => {
  await profile.getProfileInfo().then(([model, _response, err]) => {
    if (err) {
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      messageConfig.open(decodedMessage);
      return;
    } else {
      profileInfo.value = model.attributes?.result || null;

      if (profileInfo.value.image) {
        previewImage.value = profileInfo.value.image;
      }

      // 病院名の入力欄が2つ未満の場合は2つになるように調整
      if (
        !profileInfo.value.hospitals ||
        profileInfo.value.hospitals.length < 2
      ) {
        profileInfo.value.hospitals = [
          ...(profileInfo.value.hospitals || []),
          "",
          "",
        ].slice(0, 2);
      }
    }
  });
};

// キャンセルボタン押下
const cancel = () => {
  router.push({ name: "Profile" });
};

// 生年月日の未来日付のチェック
const validateBirthDate = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const birthDate = new Date(
    parseInt(birthDateParts.value.year, 10),
    birthDateParts.value.month - 1,
    birthDateParts.value.day
  );
  return birthDate < today;
};

// 郵便番号のフォーマットチェック
const validateZipCode = () => {
  let zipCode = zipcode.value.first?.trim();
  if (zipcode.value.second) zipCode += "-" + zipcode.value.second?.trim();

  if (zipCode && !/^\d{3}-\d{4}$/.test(zipCode)) {
    return false;
  }
  return true;
};

// この内容で変更ボタン押下
const save = async () => {
  const birthMonth = String(birthDateParts.value.month).padStart(2, "0");
  const birthDay = String(birthDateParts.value.day).padStart(2, "0");
  const payload = {
    ...profileInfo.value,
    userloginid: profileInfo.value.userloginid
      ? profileInfo.value.userloginid
      : undefined,
    attribute: profileInfo.value.attribute ?? undefined,
    nickname: profileInfo.value.nickname
      ? profileInfo.value.nickname.trim()
      : undefined,
    diseasecodes:
      profileInfo.value.diseasecodes?.length !== 0
        ? profileInfo.value.diseasecodes
        : [],
    zipcode1: zipcode.value.first,
    zipcode2: zipcode.value.second,
    zipcode:
      zipcode.value.first && zipcode.value.second
        ? `${zipcode.value.first}-${zipcode.value.second}`
        : undefined,
    birthdate:
      birthDateParts.value.year &&
      birthDateParts.value.month &&
      birthDateParts.value.day
        ? `${birthDateParts.value.year}/${birthMonth}/${birthDay}`
        : undefined,
    otherdiseasename: profileInfo.value.otherdiseasename,
    isStakeholder: profileInfo.value.isStakeholder,
  };

  // プロフィール更新処理
  profile.set(payload);

  //バリデーションチェック
  const validateResult: any = profile.validate();
  fieldErrors.value = {};
  if (!validateResult.valid) {
    validateResult.errors.forEach((error: { key: string; msg: string }) => {
      fieldErrors.value[error.key] = error.msg;
    });
  }
  if (!fieldErrors.value.birthdate && !validateBirthDate()) {
    fieldErrors.value.birthdate = _$t("msg_error_dateFuture");
  }
  if (
    !fieldErrors.value.zipcode1 &&
    !fieldErrors.value.zipcode2 &&
    !validateZipCode()
  ) {
    const zipcodeLabel = _$t("profile_edit_zipcode");
    fieldErrors.value.zipcode = _$t("msg_error_invalid", zipcodeLabel);
  }

  // 病院名100文字制限チェック
  profileInfo.value.hospitals.forEach((name, idx) => {
    const hospitalNameLabel = _$t("profile_edit_hospital_name");
    if (name && name.length > 100) {
      fieldErrors.value[`hospitals${idx + 1}`] = _$t(
        "msg_error_maxLength",
        hospitalNameLabel,
        "100"
      );
    }
  });

  if (Object.keys(fieldErrors.value).length > 0) {
    isError.value = true;
    return;
  }

  // バリデーションチェック後、初期化
  isError.value = false;
  await profile.updateProfile().then(([model, _response, err]) => {
    let message = "";
    if (err) {
      if (err.error.response.status === 408) {
        isSessionError.value = true;
      } else {
        isError.value = true;
      }
      message = decodeURI(err.error.response.data.message);
      messageConfig.open(message);
      return;
    } else {
      message = _$t("profile_edit_save_success");
      // モーダル表示
      messageConfig.open(message);
    }
  });
};

onMounted(async () => {
  await fetchProfileInfo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { activeMenu: menuId }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("profile_edit_title")), 1),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", _hoisted_5, [
                _createElementVNode("th", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "profile-img-bottom",
                        src: previewImage.value,
                        alt: "Preview"
                      }, null, 8, _hoisted_9)
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      class: "profile-img-upper",
                      src: "/server/necs/images/photo_camera_icon.png"
                    }, null, -1))
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    id: "imageUpload",
                    accept: "image/*",
                    style: {"display":"none"},
                    onChange: handleImageUpload
                  }, null, 32)
                ])
              ]),
              _createElementVNode("tr", _hoisted_10, [
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("profile_edit_attention")), 1)
                ])
              ]),
              _createElementVNode("tr", _hoisted_12, [
                _createElementVNode("th", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile_nickname")) + " ", 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("profile_edit_required")), 1)
                ]),
                _createElementVNode("td", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "name-input",
                    id: "nickname",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profileInfo.value.nickname) = $event))
                  }, null, 512), [
                    [_vModelText, profileInfo.value.nickname]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-required-error", { active: fieldErrors.value.nickname }])
                  }, _toDisplayString(fieldErrors.value.nickname), 3)
                ])
              ]),
              _createElementVNode("tr", _hoisted_15, [
                _createElementVNode("th", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile_mailaddress")), 1),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "member-info-required" }, "※", -1))
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "name-input",
                    id: "user_login_id",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileInfo.value.userloginid) = $event))
                  }, null, 512), [
                    [_vModelText, profileInfo.value.userloginid]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-required-error", fieldErrors.value.userloginid ? 'active' : ''])
                  }, _toDisplayString(fieldErrors.value.userloginid), 3)
                ])
              ]),
              _createElementVNode("tr", _hoisted_17, [
                _createElementVNode("th", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile_edit_attibute")) + " ", 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("profile_edit_required")), 1)
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributeOptions.value, (value, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: `attribute_${key}`,
                          name: "attribute",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profileInfo.value.attribute) = $event)),
                          value: key
                        }, null, 8, _hoisted_21), [
                          [_vModelRadio, profileInfo.value.attribute]
                        ]),
                        _createElementVNode("label", {
                          for: `attribute_${key}`
                        }, [
                          _createElementVNode("span", null, _toDisplayString(value), 1)
                        ], 8, _hoisted_22)
                      ], 64))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-required-error", fieldErrors.value.attribute ? 'active' : ''])
                  }, _toDisplayString(fieldErrors.value.attribute), 3)
                ])
              ]),
              _createElementVNode("tr", _hoisted_23, [
                _createElementVNode("th", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile_edit_birthday")) + " ", 1),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("profile_edit_required")), 1)
                ]),
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("select", {
                        class: "select-medium",
                        id: "birth_date_year",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((birthDateParts.value.year) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: year,
                            value: year
                          }, _toDisplayString(year), 9, _hoisted_28))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, birthDateParts.value.year]
                      ]),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("profile_edit_year")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("select", {
                        class: "select-small",
                        id: "birth_date_month",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((birthDateParts.value.month) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: month,
                            value: month
                          }, _toDisplayString(month), 9, _hoisted_31))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, birthDateParts.value.month]
                      ]),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("profile_edit_month")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("select", {
                        class: "select-small",
                        id: "birth_date_day",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((birthDateParts.value.day) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: day,
                            value: day
                          }, _toDisplayString(day), 9, _hoisted_34))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, birthDateParts.value.day]
                      ]),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("profile_edit_day")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-required-error", fieldErrors.value.birthdate ? 'active' : ''])
                  }, _toDisplayString(fieldErrors.value.birthdate), 3)
                ])
              ]),
              _createElementVNode("tr", _hoisted_36, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_edit_zipcode")), 1),
                _createElementVNode("td", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "zip_code_first",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((zipcode.value.first) = $event)),
                      maxlength: "3"
                    }, null, 512), [
                      [_vModelText, zipcode.value.first]
                    ]),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "zipcode-separateline" }, "ー", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "zip_code_second",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((zipcode.value.second) = $event)),
                      maxlength: "4"
                    }, null, 512), [
                      [_vModelText, zipcode.value.second]
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-required-error", 
                    fieldErrors.value.zipcode1 ||
                    fieldErrors.value.zipcode2 ||
                    fieldErrors.value.zipcode
                      ? 'active'
                      : ''
                  ])
                  }, _toDisplayString(fieldErrors.value.zipcode1 ||
                    fieldErrors.value.zipcode2 ||
                    fieldErrors.value.zipcode), 3)
                ])
              ]),
              _createElementVNode("tr", _hoisted_39, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_edit_gender")), 1),
                _createElementVNode("td", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(genderOptions.value, (value, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: `gender_${key}`,
                          name: "gender",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((profileInfo.value.gender) = $event)),
                          value: key
                        }, null, 8, _hoisted_42), [
                          [_vModelRadio, profileInfo.value.gender]
                        ]),
                        _createElementVNode("label", {
                          for: `gender_${key}`
                        }, [
                          _createElementVNode("span", null, _toDisplayString(value), 1)
                        ], 8, _hoisted_43)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_44, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_status_patient_group")), 1),
                _createElementVNode("td", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusPatientGroupOptions.value, (option, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: `status_patient_group_${option.value}`,
                          name: "status_patient_group",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((profileInfo.value.statuspatientgroup) = $event)),
                          value: option.value
                        }, null, 8, _hoisted_47), [
                          [_vModelRadio, profileInfo.value.statuspatientgroup]
                        ]),
                        _createElementVNode("label", {
                          for: `status_patient_group_${option.value}`
                        }, [
                          _createElementVNode("span", null, _toDisplayString(option.label), 1)
                        ], 8, _hoisted_48)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_49, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_identify_code")), 1),
                _createElementVNode("td", _hoisted_50, [
                  _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("profile_identify_code_note")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "name-input",
                    id: "identify_code",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((profileInfo.value.identifycode) = $event))
                  }, null, 512), [
                    [_vModelText, profileInfo.value.identifycode]
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_52, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_edit_hospital_name")), 1),
                _createElementVNode("td", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileInfo.value.hospitals, (hospital, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "hospital-name-input",
                        key: idx
                      }, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("profile_edit_hospital_name_label")) + _toDisplayString(idx + 1), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "name-input",
                          "onUpdate:modelValue": ($event: any) => ((profileInfo.value.hospitals[idx]) = $event),
                          placeholder: _ctx.$t('profile_edit_hospital_placeholder')
                        }, null, 8, _hoisted_56), [
                          [_vModelText, profileInfo.value.hospitals[idx]]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["input-required-error", 
                        fieldErrors.value[`hospitals${idx + 1}`] ? 'active' : ''
                      ])
                        }, _toDisplayString(fieldErrors.value[`hospitals${idx + 1}`]), 3)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_57, [
                      (profileInfo.value.hospitals.length < 10)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "add-hospital-name-btn",
                            onClick: addHospital
                          }, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "add-hospital-name-btn-icon" }, "＋", -1)),
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t("profile_edit_add_hospital_name")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (profileInfo.value.hospitals.length >= 10)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.$t("profile_edit_limit_hospital_name")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-required-error", fieldErrors.value.hospitals ? 'active' : ''])
                    }, _toDisplayString(fieldErrors.value.hospitals), 3)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_60, [
                _createElementVNode("th", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("profile_edit_disease_name")) + " ", 1),
                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "member-info-required" }, "※", -1))
                ]),
                _createElementVNode("td", _hoisted_61, [
                  (!fieldErrors.value.diseasecodes)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(profileInfo.value.isStakeholder
                      ? _ctx.$t("profile_disease_stakeholder")
                      : (profileInfo.value.diseasenames || "") +
                        (profileInfo.value.diseasenames &&
                        profileInfo.value.otherdiseasename
                          ? ", "
                          : "") +
                        (profileInfo.value.otherdiseasename
                          ? _ctx.$t("profile_disease_other_colon") +
                            profileInfo.value.otherdiseasename
                          : "")), 1))
                    : _createCommentVNode("", true),
                  (fieldErrors.value.diseasecodes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(fieldErrors.value.diseasecodes), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "profile-change-modal-button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (isDiseaseModalOpen.value = true))
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("img", { src: "/server/necs/images/settings_24dp_FILL1_wght400_GRAD0_opsz24.png" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("button_change_disease")), 1)
                  ])
                ])
              ]),
              _createElementVNode("tr", _hoisted_64, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("profile_edit_interest")), 1),
                _createElementVNode("td", _hoisted_65, [
                  _createElementVNode("span", null, _toDisplayString(profileInfo.value.tagnames), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "profile-change-modal-button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (isModalOpen.value = true))
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("img", { src: "/server/necs/images/settings_24dp_FILL1_wght400_GRAD0_opsz24.png" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("button_change_interest")), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("button", {
              type: "button",
              class: "profile-cansel-button",
              onClick: cancel
            }, _toDisplayString(_ctx.$t("button_cancel_label")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "profile-change-button",
              onClick: _withModifiers(save, ["prevent"])
            }, _toDisplayString(_ctx.$t("profile_edit_button_submit")), 1)
          ])
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (_unref(messageConfig).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 0 }, _unref(messageConfig), {
          onOk: _unref(messageConfig).close,
          onCancel: _unref(messageConfig).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (isDiseaseModalOpen.value)
      ? (_openBlock(), _createBlock(DiseaseModal, {
          key: 1,
          selectedDiseaseCodes: profileInfo.value.diseasecodes,
          otherdiseasename: profileInfo.value.otherdiseasename,
          isStakeholder: profileInfo.value.isStakeholder,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (isDiseaseModalOpen.value = false)),
          onSave: updateDiseases
        }, null, 8, ["selectedDiseaseCodes", "otherdiseasename", "isStakeholder"]))
      : _createCommentVNode("", true),
    (isModalOpen.value)
      ? (_openBlock(), _createBlock(InterestModal, {
          key: 2,
          selectedInterests: profileInfo.value.tagids,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (isModalOpen.value = false)),
          onSave: updateInterests
        }, null, 8, ["selectedInterests"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})